/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-field.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/cdk/scrolling';
import * as i6 from '@angular/cdk/overlay';
import * as i7 from '@angular/cdk/platform';
import * as i8 from '@angular/cdk/bidi';
import * as i9 from '@angular/common';
import * as i10 from '../../../../../../app/modules/fields/components/select-field/select-field.component';
import * as i11 from '../../../../../../app/modules/fields/services/select-field/select-field.service';
import * as i12 from '../../../../../../app/modules/user/services/current-user/current-user.service';
const styles_SelectFieldComponent:any[] = [i0.styles];
export const RenderType_SelectFieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectFieldComponent,data:{}});
function View_SelectFieldComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-option',
      [['class','mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',
          (null as any)],[2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],
          [8,'id',0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
              (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
          ad = (pd_0 && ad);
        }
        if (('keydown' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(1,49152,[[1,4],['select',
      4]],0,i3.MdOption,[i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MdOptgroup],[2,i3.MATERIAL_COMPATIBILITY_MODE]],
      {value:[0,'value'],disabled:[1,'disabled']},(null as any)),i1.ɵdid(2,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),(_l()(),i1.ɵted(3,0,['\n        ','\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_8:any = _v.context.$implicit.id;
    const currVal_9:any = _co.getDisabled(_v.context.$implicit);
    _ck(_v,1,0,currVal_8,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_10:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10);
  });
}
function View_SelectFieldComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(1,
      0,(null as any),(null as any),12,'md-select',[['class','mat-select'],['floatPlaceholder',
          'never'],['role','listbox']],[[2,'completed',(null as any)],[1,'tabindex',
          0],[1,'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',0],[1,'aria-disabled',
          0],[1,'aria-invalid',0],[1,'aria-owns',0],[1,'aria-multiselectable',0],[2,
          'mat-select-disabled',(null as any)],[2,'mat-select-invalid',(null as any)],
          [2,'mat-select-required',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'change'],[(null as any),
          'keydown'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,5)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,5)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('change' === en)) {
          const pd_2:any = ((<any>_co.handleChange($event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(2,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(3,671744,(null as any),0,i4.FormControlName,[[3,i4.ControlContainer],
      [8,(null as any)],[8,(null as any)],[8,(null as any)]],{name:[0,'name']},(null as any)),
      i1.ɵprd(2048,(null as any),i4.NgControl,(null as any),[i4.FormControlName]),
      i1.ɵdid(5,1294336,(null as any),3,i3.MdSelect,[i5.ViewportRuler,i1.ChangeDetectorRef,
          i6.Overlay,i7.Platform,i1.Renderer2,i1.ElementRef,[2,i8.Directionality],
          [2,i4.NgForm],[2,i4.FormGroupDirective],[2,i4.NgControl],[8,(null as any)],
          [2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS],i3.MD_SELECT_SCROLL_STRATEGY],{placeholder:[0,
          'placeholder'],floatPlaceholder:[1,'floatPlaceholder']},{change:'change'}),
      i1.ɵqud(603979776,1,{options:1}),i1.ɵqud(603979776,2,{optionGroups:1}),i1.ɵqud(335544320,
          3,{customTrigger:0}),i1.ɵdid(9,16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,1,['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),1,1,(null as any),View_SelectFieldComponent_2)),
      i1.ɵdid(12,802816,(null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          1,['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(15,
          0,(null as any),(null as any),3,'md-hint',[['align','start'],['class','mat-hint']],
          [[2,'mat-right',(null as any)],[1,'id',0],[1,'align',0]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(16,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(17,16384,(null as any),0,i3.MdHint,([] as any[]),{align:[0,'align']},
          (null as any)),(_l()(),i1.ɵted(18,(null as any),['\n      ','\n      ','\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_19:any = _co.getKey();
    _ck(_v,3,0,currVal_19);
    const currVal_20:any = _co.fieldValue.field.name;
    const currVal_21:any = 'never';
    _ck(_v,5,0,currVal_20,currVal_21);
    const currVal_22:any = _co.fieldValue.field.options;
    _ck(_v,12,0,currVal_22);
    const currVal_26:any = 'start';
    _ck(_v,17,0,currVal_26);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.fieldValue.select_value != (null as any));
    const currVal_1:any = i1.ɵnov(_v,5).tabIndex;
    const currVal_2:any = i1.ɵnov(_v,5)._ariaLabel;
    const currVal_3:any = i1.ɵnov(_v,5).ariaLabelledby;
    const currVal_4:any = i1.ɵnov(_v,5).required.toString();
    const currVal_5:any = i1.ɵnov(_v,5).disabled.toString();
    const currVal_6:any = i1.ɵnov(_v,5)._isErrorState();
    const currVal_7:any = i1.ɵnov(_v,5)._optionIds;
    const currVal_8:any = i1.ɵnov(_v,5).multiple;
    const currVal_9:any = i1.ɵnov(_v,5).disabled;
    const currVal_10:any = i1.ɵnov(_v,5)._isErrorState();
    const currVal_11:any = i1.ɵnov(_v,5).required;
    const currVal_12:any = i1.ɵnov(_v,9).ngClassUntouched;
    const currVal_13:any = i1.ɵnov(_v,9).ngClassTouched;
    const currVal_14:any = i1.ɵnov(_v,9).ngClassPristine;
    const currVal_15:any = i1.ɵnov(_v,9).ngClassDirty;
    const currVal_16:any = i1.ɵnov(_v,9).ngClassValid;
    const currVal_17:any = i1.ɵnov(_v,9).ngClassInvalid;
    const currVal_18:any = i1.ɵnov(_v,9).ngClassPending;
    _ck(_v,1,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17,currVal_18]);
    const currVal_23:any = (i1.ɵnov(_v,17).align == 'end');
    const currVal_24:any = i1.ɵnov(_v,17).id;
    const currVal_25:any = (null as any);
    _ck(_v,15,0,currVal_23,currVal_24,currVal_25);
    const currVal_27:any = (_co.fieldValue.field.required? '': '(Not Required)');
    const currVal_28:any = (_co.fieldValue.field.hint? _co.fieldValue.field.hint: '');
    _ck(_v,18,0,currVal_27,currVal_28);
  });
}
export function View_SelectFieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,(null as any),
      (null as any),(null as any),(null as any),(_v,en,$event) => {
        var ad:boolean = true;
        if (('submit' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onSubmit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reset' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onReset()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,540672,(null as any),0,i4.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i1.ɵprd(2048,
      (null as any),i4.ControlContainer,(null as any),[i4.FormGroupDirective]),i1.ɵdid(3,
      16384,(null as any),0,i4.NgControlStatusGroup,[i4.ControlContainer],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_SelectFieldComponent_1)),i1.ɵdid(6,
      16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i10.SelectFieldComponent = _v.component;
    const currVal_0:any = _co.form;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.fieldValue.field.options;
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_SelectFieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-select',
      ([] as any[]),[[2,'not-required',(null as any)]],(null as any),(null as any),
      View_SelectFieldComponent_0,RenderType_SelectFieldComponent)),i1.ɵdid(1,114688,
      (null as any),0,i10.SelectFieldComponent,[i11.SelectFieldService,i12.CurrentUserService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).isNotRequired;
    _ck(_v,0,0,currVal_0);
  });
}
export const SelectFieldComponentNgFactory:i1.ComponentFactory<i10.SelectFieldComponent> = i1.ɵccf('app-select',
    i10.SelectFieldComponent,View_SelectFieldComponent_Host_0,{editable:'editable',
        form:'form',fieldValue:'fieldValue'},{fieldValueChange:'fieldValueChange',
        edited:'edited'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/select-field/select-field.component.ngfactory.ts